import { render, staticRenderFns } from "./MainBannerAndContent.vue?vue&type=template&id=622df4f9&scoped=true"
import script from "./MainBannerAndContent.vue?vue&type=script&lang=ts"
export * from "./MainBannerAndContent.vue?vue&type=script&lang=ts"
import style0 from "./MainBannerAndContent.vue?vue&type=style&index=0&id=622df4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622df4f9",
  null
  
)

export default component.exports